import React, { useRef } from "react";
// import PropTypes from "prop-types";
import "./style.css";
import { queuePad } from "../../utility";
import { useAntrian } from "./context";
import ReactToPrint from "react-to-print";
import Receipt from "../../components/Receipt";

function LihatAntrian() {
  let componentRef = useRef();
  const { state, dispatch } = useAntrian();
  if (state.step === 3) {
    return (
      <div className="result">
        <h3>Berhasil!</h3>
        <button
          type="button"
          onClick={() => {
            dispatch({
              type: "CLEAR",
            });
          }}
        >
          Kembali
        </button>
      </div>
    );
  }
  return (
    <div className="result">
      <h4>Nomor Antiran:</h4>
      <h1>{queuePad(state.antrian?.urutan)}</h1>
      <table>
        <tbody>
          <tr>
            <td>NIK</td>
            <td>:</td>
            <td>{state.antrian?.nik}</td>
          </tr>
          <tr>
            <td>Nama Lengkap</td>
            <td>:</td>
            <td>{state.antrian?.name}</td>
          </tr>
          <tr>
            <td>No HP</td>
            <td>:</td>
            <td>{state.antrian?.phone}</td>
          </tr>
          <tr>
            <td>Instansi yang dituju</td>
            <td>:</td>
            <td>{state.antrian?.nama_layanan}</td>
          </tr>
          <tr>
            <td>Layanan terkait</td>
            <td>:</td>
            <td>{state.antrian?.nama_sub_layanan}</td>
          </tr>
        </tbody>
      </table>

      <ReactToPrint
        trigger={() => (
          <button type="button" className="cta">
            Ambil
          </button>
        )}
        onBeforePrint={() => {
          dispatch({
            type: "SWITCH_STEP",
            to: 3,
          });
        }}
        content={() => componentRef}
        pageStyle={`
          @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;600&display=swap');
        `}
      />
      <div
        style={{
          display: "none",
        }}
      >
        <Receipt
          data={state.antrian}
          type="Online"
          ref={(el) => (componentRef = el)}
        />
      </div>
    </div>
  );
}

// LihatAntrian.propTypes = {};
export default LihatAntrian;
